import { Input } from "antd";
import { FaArrowCircleRight } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { useInfoUser } from "../../../store/UserStore";
import { useDirectoryContext } from "./DirectoryContext";
import { Organization } from "./Organization";

const ShareMessageDirectory = () => {
  const { languageMap } = useInfoUser();
  const { setIsCheckedList, handleFilterOrg, valueName } =
    useDirectoryContext();

  return (
    <div>
      <div className="flex items-center gap-[10px]">
        <Input
          value={valueName}
          placeholder={languageMap?.["menu.search.placeholder"] ?? "Search"}
          onChange={(event) => {
            handleFilterOrg(event.target.value);
          }}
          prefix={<IoSearchOutline size={15} />}
          allowClear
        />
        <button
          type="button"
          className="checked-list-icon"
          onClick={() => setIsCheckedList(true)}
        >
          <FaArrowCircleRight size={20} />
        </button>
      </div>
      <Organization onlyView={false} isForwardMail={false} />
    </div>
  );
};

export { ShareMessageDirectory };
